import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

class ConfirmButton extends React.Component {
  render() {
    const { text, disabled, t, onClick, className } = this.props;
    return (
      <button
        className={`confirm-button-container ${className || ""} ${
          disabled ? "confirm-button-container-disabled" : ""
        }`}
        disabled={disabled}
        onClick={() => onClick && onClick()}
      >
        {text || t("common_next_button_title")}
      </button>
    );
  }
}

ConfirmButton.propTypes = {
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default withTranslation()(ConfirmButton);
